import { ConditionalAccessPolicy, User } from '@microsoft/microsoft-graph-types-beta';
import { GenericCapSchema_Data } from 'projects/angular-clarity/src/app/modules/sway/models/baseline-schemas/generic-cap-schema-model';
import { remediateGenericCapPolicy } from '../shared/cap-generic-remediate';
import { getCAPBaselineDisplayName } from '../shared/cap-schema';

export function remediate(
    _tenant: string,
    data: ConditionalAccessPolicy[],
    schema: GenericCapSchema_Data,
    _users: User[],
    key,
) {
    const id = key;
    let policyItem;

    if (id) {
        policyItem = data.find((res) => res.id === id);
    } else {
        policyItem = data.find((res) => res.displayName === getCAPBaselineDisplayName(schema));
    }

    return remediateGenericCapPolicy(_tenant, schema, policyItem);
}
